import { useInjectSaga } from 'shared/lib/@reduxjs'

import { betContainerSaga } from './saga'

const KEY = 'betContainer'

export function useBetContainer() {
  useInjectSaga({ key: KEY, saga: betContainerSaga })
}
